import { GroupedByApr } from 'utils';

export const PLACEHOLDER_GROUPED: GroupedByApr = {
  '0': [
    {
      apr: 0,
      apr_type: 'INTEREST_FREE',
      charge: 0,
      deferred_duration: 0,
      duration: 12,
      enabled: true,
      fee: 1000,
      finance_types: ['primary'],
      max_deposit_pct: 5000,
      max_deposit_value: 0,
      max_job_value: 2500000,
      min_charge: 0,
      min_deposit_pct: 0,
      min_deposit_value: 0,
      min_job_value: 100000,
      name: 'INTEREST_FREE_12',
      provider: 'demo',
      work_types: [],
    },
  ],
  '1490': [
    {
      apr: 1490,
      apr_type: 'INTEREST_BEARING',
      charge: 0,
      deferred_duration: 0,
      duration: 24,
      enabled: true,
      fee: 0,
      finance_types: ['primary'],
      max_deposit_pct: 5000,
      max_deposit_value: 0,
      max_job_value: 2500000,
      min_charge: 0,
      min_deposit_pct: 0,
      min_deposit_value: 0,
      min_job_value: 100000,
      name: 'INTEREST_BEARING_24_1490',
      provider: 'demo',
      work_types: [],
    },
  ],
};
